import "core-js/modules/es.object.keys.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-85e8cbc6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "Video"
};
var _hoisted_2 = {
  key: 0,
  class: "err-msg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PlayListHead = _resolveComponent("PlayListHead");

  var _component_VideoList = _resolveComponent("VideoList");

  var _component_Loading = _resolveComponent("Loading");

  return _ctx.tagList.length && Object.keys(_ctx.userData).length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 头部标签区域 "), _createVNode(_component_PlayListHead, {
    listTag: _ctx.tagRList,
    allTagList: _ctx.tagList,
    scrollTopTitle: "全部视频",
    onChangeTagName: _ctx.changeTagName
  }, null, 8
  /* PROPS */
  , ["listTag", "allTagList", "onChangeTagName"]), _ctx.errMsg.indexOf('暂无') !== -1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 暂无推荐视频，看看其他内容吧~ ")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 视频列表区域 "), _createVNode(_component_VideoList, {
    videoList: _ctx.videoList,
    isBlod: true,
    onScrollLoad: _ctx.scrollLoad
  }, null, 8
  /* PROPS */
  , ["videoList", "onScrollLoad"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ))])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1,
    isIcon: !Object.keys(_ctx.userData).length ? false : true,
    loadTitle: !Object.keys(_ctx.userData).length ? '请登录后查看！' : '载入中...'
  }, null, 8
  /* PROPS */
  , ["isIcon", "loadTitle"]));
}